"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Box = exports.shouldForwardProp = exports.noWrap = exports.truncate = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const css_1 = __importDefault(require("@styled-system/css"));
const should_forward_prop_1 = require("@styled-system/should-forward-prop");
const lodash_1 = require("lodash");
const react_1 = require("react");
const styled_system_1 = require("styled-system");
const systemProps = styled_system_1.compose(styled_system_1.margin, styled_system_1.padding, styled_system_1.color, styled_system_1.background, styled_system_1.typography, styled_system_1.layout, styled_system_1.flexbox, styled_system_1.grid, styled_system_1.border, styled_system_1.position, styled_system_1.shadow, styled_system_1.space);
const emotionShouldForwardProp = should_forward_prop_1.createShouldForwardProp([
    ...(systemProps.propNames || []),
    'd',
    'textDecoration',
    'pointerEvents',
    'visibility',
    'transform',
    'cursor',
    'fill',
    'stroke',
]);
const nativeHTMLPropAlias = ['htmlWidth', 'htmlHeight'];
const truncate = (props) => {
    if (props.shouldTruncate) {
        return {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
        };
    }
    return {};
};
exports.truncate = truncate;
const noWrap = (props) => {
    if (props.noWrap) {
        return {
            whiteSpace: 'nowrap',
        };
    }
    return {};
};
exports.noWrap = noWrap;
function shouldForwardProp(prop) {
    if (nativeHTMLPropAlias.includes(prop)) {
        return true;
    }
    else {
        return emotionShouldForwardProp(prop);
    }
}
exports.shouldForwardProp = shouldForwardProp;
const otherProps = styled_system_1.system({
    textDecoration: { property: 'textDecoration' },
    transform: { property: 'transform' },
    transition: { property: 'transition' },
    outline: { property: 'outline' },
});
const allStyles = styled_system_1.compose(systemProps, otherProps);
const Box_ = styled_1.default('div', {
    shouldForwardProp,
})(allStyles, exports.truncate, exports.noWrap, pseudoProps);
exports.Box = react_1.forwardRef(function Box(_a, ref) {
    var _b;
    var { debug } = _a, props = __rest(_a, ["debug"]);
    return (jsx_runtime_1.jsx(Box_, Object.assign({ ref: ref }, filterUndefined({
        style: debug
            ? Object.assign(Object.assign({}, ((_b = props.style) !== null && _b !== void 0 ? _b : {})), { outlineColor: 'red', outlineWidth: '2px', outlineOffset: '-1px', outlineStyle: 'solid' }) : undefined,
    }), props), void 0));
});
function filterUndefined(obj) {
    return lodash_1.pickBy(obj, lodash_1.identity);
}
const pseudoSelectors = {
    _hover: '&:hover',
    _disabled: '&[disabled]',
    _lastOfType: '&:last-of-type',
    _firstOfType: '&:first-of-type',
    _focus: '&:focus',
    _focusWithin: '&:focus-within',
    _empty: '&:empty',
};
function pseudoProps(props = {}) {
    let res = {};
    for (const key in pseudoSelectors) {
        const typedKey = key;
        const value = props[typedKey];
        if (value) {
            res = lodash_1.merge(res, { [pseudoSelectors[typedKey]]: allStyles(value) });
        }
    }
    return css_1.default(res);
}
//# sourceMappingURL=index.js.map